export const GTM_EVENTS_DATA: {
  [index: string]: Record<string, string>;
} = {
  CREATE: {
    event: 'interaction_click create wishlist',
    amp_event_name: 'Click on create wishlist',
    e_category: 'navigation',
    e_action: 'Click on create wishlist',
    interaction_hit: 'False',
  },
  MODIFY: {
    event: 'interaction_click modify wishlist',
    e_category: 'navigation',
    e_action: 'Click on modify wishlist',
    event_trigger: 'wishlist',
    amp_event_name: 'Click on modify wishlist',
    interaction_hit: 'False',
  },
  DELETE_WISHLIST: {
    event: 'interaction_click deleting confirmation wishlist',
    event_trigger: 'wishlist',
    amp_event_name: 'Delete wishlist complete',
    e_category: 'navigation',
    e_action: 'Delete wishlist complete',
    interaction_hit: 'False',
  },
  DELETE: {
    event: 'interaction_click delete product',
    event_trigger: 'wishlist',
    amp_event_name: 'Click on delete product from wishlist',
    e_category: 'navigation',
    e_action: 'Click on delete product from wishlist',
    interaction_hit: 'False',
  },
  RENAME: {
    event: 'interaction_click renaming confirmation wishlist',
    event_trigger: 'wishlist',
    amp_event_name: 'Renaming wishlist complete',
    e_category: 'navigation',
    e_action: 'Renaming wishlist complete',
    interaction_hit: 'False',
  },
  CHANGE_QTY: {
    event: 'interaction_click change quantity',
    e_category: 'navigation',
    e_action: 'Change quantity from wishlist',
    amp_event_name: 'Change quantity from wishlist',
    interaction_hit: 'False',
  },
  HEADER_NAV: {
    event: 'interaction_click wishlist header',
    event_trigger: 'header',
    amp_event_name: 'Click on wishlist header',
    e_category: 'navigation',
    e_action: 'Click on wishlist header',
    interaction_hit: 'False',
  },
  WISHLIST_DETAILS: {
    event: 'interaction_wishlist details',
    amp_event_name: 'Wishlist details',
  },
};
